compiler('[data-autofocus-on-load]', (element) => {
  element.focus();
});
